/* eslint-disable react/display-name */

// libraries
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

import styled from 'styled-components';

// styled components
import { Flex } from 'shared/styledComponents';
import { Title } from 'shared/typography';

// styles
import 'shared/sliderStyles.css';
import devices from 'theme/devices';

const Wrapper = styled(Flex)<any>`
  min-height: ${({ isRelatedArticle }): string => (isRelatedArticle ? '65px' : 'unset')};
  justify-content: center;
  flex-wrap: wrap;
  line-height: 25px;
`;

const AuthorName = styled(Title)`
  font-family: ${({ theme: { fonts } }): string => fonts.wigrumRegular};

  @media ${devices.mobile} {
    font-size: 14px;
    line-height: 22px;
  }
`;

const AuthorNameLink = styled(AuthorName)`
  text-decoration: underline;
`;

interface ArticleAuthorNameProps {
  providerName: string;
  author: string;
  credentials: string[];
  size?: string;
  isRelatedArticle?: boolean;
  providerSlug?: string;
}

const ArticleAuthorName = ({
  providerName,
  providerSlug,
  author,
  credentials,
  size,
  isRelatedArticle,
}: ArticleAuthorNameProps): JSX.Element => (
  <Wrapper isRelatedArticle={isRelatedArticle}>
    <AuthorName size={size}>By </AuthorName>
    &nbsp;
    {providerName ? (
      <>
        <AuthorNameLink as={ReactRouterLink} to={`/maternal-specialist/${providerSlug}`} size={size}>
          {credentials?.length ? `${providerName},` : `${providerName}`}
        </AuthorNameLink>
      </>
    ) : (
      <>
        <AuthorName size={size}>{credentials?.length ? `${author},` : `${author}`} </AuthorName>
      </>
    )}
    &nbsp;
    {!!credentials?.length &&
      credentials.map((credential: string) =>
        credentials[credentials.length - 1] === credential ? (
          <AuthorName key={credential} size={size}>
            {credential}
          </AuthorName>
        ) : (
          <AuthorName key={credential} size={size}>
            {credential},&nbsp;
          </AuthorName>
        ),
      )}
  </Wrapper>
);

export default ArticleAuthorName;
